<template>
  <div class="magic_input_wapper" v-if="unActive!=null">
    <div class="placeholder" :style="{'color': errorMessage ? 'rgb(251, 99, 64)' : placeholderColor, 'fontSize': unActive? fontSize+'px':'', 'marginTop': unActive? textOffsetBot +'px':''}" :class="{placeholder_active:unActive}">{{placeholder}}</div>
    <div class="flex flex-row">
      <input
        :disabled='disabled'
        :min="min"
        :max="max"
        :style="{'height': heightProp, 'width': imgSrc ? 'calc(100%)' : '100%' , 'color': errorMessage ? 'rgb(251, 99, 64)' : textColor, borderColor: '#c1c1c1', fontSize: fontSize +'px'}"
        autocomplete="off"
        ref='input'
        :type="type"
        v-model="inputValue"
        :value="value"
        :maxlength="maxlength"
        :step="step"
        class="form-control"
        :onkeydown="`javascript: return event.keyCode == 69 && ${type === 'number'} ? false : true`"
        @focus="handleInputFocus(false)"
        @blur="handleInputFocus(true)"
        @input="onChange">
      <img class="city-location-icon mb-3 mt-auto" :src="imgSrc" v-if="imgSrc" v-on:click="onClickIcon"/>
    </div>
    <div v-if='showError' class="text-error mt-1"><span v-if="errorMessage">{{ errorMessage }}</span></div>
  </div>
</template>

<script>
export default {
  name: 'MagicVueInput',
  data() {
    return {
      unActive: null,
      inputValue: '',
      closeShow: false,
    };
  },
  props: {
    formatter: {
      type: Function,
      default: null
    },
    imgSrc: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Type here',
    },
    value: {
      type: String
    },
    maxlength: {
      type: Number,
      default: 150,
    },
    max: {
      type: Number,
      default: 99999999,
    },
    type: {
      type: String,
      default: 'text',
    },
    textColor: {
      type: String,
      default: 'blue',
    },
    lineColor: {
      type: String,
      default: 'blue',
    },
    placeholderColor: {
      type: String,
      default: 'blue',
    },
    fontSize: {
      type: Number,
      default: 30,
    },
    heightProp: {
      type: String,
      default: '2.3rem',
    },
    textOffsetBot: {
      type: Number,
      default: 22,
    },
    onKeyUp: {
      type: Function,
    },
    onClick: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: String,
      default: 'any'
    },
    showError: {
      type: Boolean,
      default: true,
    },
    min: {
      type: String,
      default: "0"
    }
  },
  watch: {
    inputValue(value) {
      if (this.formatter) {
        value = this.formatter(value);
      }
      this.$emit('input', value);

      this.inputValue = value;
       this.unActive = this.inputValue === '';
    },
    value(val) {
      // this.$refs.input.focus();
      if (this.formatter) {
        val = this.formatter(val);
      }
      this.$emit('input', val);

      this.inputValue = val;
    }
  },
  mounted() {
    this.inputValue = this.value;
    this.unActive = this.inputValue === '';
  },
  methods: {
    handleInputFocus(flag) {
      this.unActive = this.inputValue === '' && flag;
    },
    handleClear() {
      this.inputValue = '';
      this.$refs.input.focus();
    },
    onChange(event) {
      if (this.onKeyUp) {
        this.onKeyUp(event);
      }
    },
    onClickIcon(e) {
      e.preventDefault();
      this.handleInputFocus(false);
      this.$refs.input.focus();
      const val = this.onClick();
      this.inputValue = val;
    }
  },
};
</script>

<style scoped>
  img {
    width: 20px;
    height: 25px;
    margin-left: -20px;
    cursor: pointer;
    z-index: 99;
  }
  .magic_input_wapper i {
    cursor: pointer;
    position: relative;
    z-index: 3;
    margin-top: -35px;
    transform: translateX(0px);
    float: right;
    display: block;
    height: 16px;
    width: 16px;
    font-size: 22px;
    transition: .3s all ease-in-out;
    background-size: contain;
    background-repeat: no-repeat;
    font-style: normal;
    background-position: center center;
  }
  .magic_input_wapper input {
    font-size: 1rem;
    padding-right: 30px;
    text-indent: 0;
    letter-spacing: 1px;
  }
  .placeholder {
    transition: .3s all ease-in-out;
    position: absolute;
    transform: translateY(-20px);
    z-index: 1;
    color: royalblue;
    opacity: .7;
    font-style: normal;
    font-family: 'Segoe UI light';
  }
  .placeholder_active {
    opacity: 1;
  }
  input:-webkit-autofill {
    background-color: transparent !important;
  }
  input[type="text"],
  input[type="number"],
  input[type="email"],
  input[type="password"] {
      display: block;
      border: none;
      background-color: transparent;
      border-bottom: 1px solid royalblue;
      width: 100%;
      color: royalblue;
      outline: none;
      z-index: 2;
      position: relative;
      font-family: 'Segoe UI light';
  }
  .text-error {
    color: red !important;
    min-height: 15px;
    font-family: 'Segoe UI light';
    font-size: 12px !important;
  }

  .city-location-icon {
      height: 20px;
      width: 20px;
      background-repeat: no-repeat;
  }
</style>
